import { ArrowButton } from "./ArrowButton";
import { LargeButton } from "./LargeButton";

interface Props {
  className?: string;
  largeButtonText?: string;
  arrowButtonText?: string;
  onClick?: () => void;
}

export const CallToAction = ({ 
  className = "", 
  largeButtonText = "CONTACT US",
  arrowButtonText = "Watch Our Videos",
  onClick
}: Props): JSX.Element => {
  return (
    <div className={`flex flex-col items-center justify-center pt-[30px] pb-20 px-[170px] relative ${className}`}>
      <div className="flex flex-col items-center justify-center gap-[50px] relative self-stretch w-full flex-[0_0_auto]">
        <div className="flex flex-col h-[28.89px] items-center justify-center relative self-stretch w-full">
          <div className="relative self-stretch mt-[-1.06px] font-section-divider font-[number:var(--section-divider-font-weight)] text-[#ffe1b8] text-[length:var(--section-divider-font-size)] text-center tracking-[var(--section-divider-letter-spacing)] leading-[var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
            ........................................................................................................................................
          </div>
        </div>

        <ArrowButton className="!flex-[0_0_auto]" text={arrowButtonText} />
        <LargeButton text={largeButtonText} onClick={onClick} />
      </div>
    </div>
  );
}; 